import React, { Component } from "react";
import ViewHelpers from "../components/viewHelpers";
import { matchPath } from "react-router";
import "../../../assets/scss/style.scss";

import ImageActions from "../../actions/imageActions";
import ImageStore from "../../stores/imageStore";

export default class DefaultLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fontsStored: false,
			onHome: false,
			imageStore: ImageStore.getState()
		};

		this.viewHelpers = new ViewHelpers();
		this.cacheVer = "1.92";
	}

	componentDidMount() {
		const { imageStore } = this.state;
		if (imageStore.framesLoaded === 0) ImageActions.init();

		let sessionFonts = sessionStorage.getItem("webfonts");

		if (sessionFonts) {
			this.setState({ fontsStored: true });
		}

		let WebFont = require("webfontloader");

		WebFont.load({
			// classes: false,
			google: {
				families: [
					"Alegreya+Sans:100,300,400,500,700,800,900",
					"Saira:100,400,700",
					"Saira+Semi+Condensed:100,400,500,700",
					"Rubik:300,400,500,700,900"
				],
				timeout: 200,
				active: function() {
					sessionStorage.webfonts = true;
				}
			}
		});

		this.overloadScrollCheck();
	}

	componentWillUpdate(nextProps) {
		this.overloadScrollCheck();
	}

	overloadScrollCheck = () => {
		const { onHome } = this.state;
		const isHome = matchPath(window.location.pathname, {
			path: "/",
			exact: true
		});
		if (!!isHome !== onHome) this.setState({ onHome: !onHome });
	};

	render() {
		let { fontsStored, onHome } = this.state;
		const { routes } = this.props;

		return (
			<html lang="en" className={`${fontsStored ? "wf-active" : ""}`}>
				<head>
					<meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
					<meta
						name="viewport"
						content="width=device-width, initial-scale=1, shrink-to-fit=no, viewport-fit=cover"
					/>
					<meta name="theme-color" content="#89b825" />
					<meta name="apple-mobile-web-app-status-bar-style" content="black" />

					<meta name="description" content="Qwixskinz Custom Race Suits" />
					<meta name="author" content="AgileCollab" />

					<link
						rel="apple-touch-icon"
						sizes="180x180"
						href="/images/logo/apple-touch-icon.png"
					/>
					<link
						rel="icon"
						type="image/png"
						sizes="32x32"
						href="/images/logo/favicon-32x32.png"
					/>
					<link
						rel="icon"
						type="image/png"
						sizes="16x16"
						href="/images/logo/favicon-16x16.png"
					/>
					<link rel="manifest" href="/images/logo/manifest.json" />
					<link
						rel="mask-icon"
						href="/images/logo/safari-pinned-tab.svg"
						color="#7eaf21"
					/>
					<link rel="shortcut icon" href="/images/logo/favicon.ico" />
					<meta name="apple-mobile-web-app-title" content="Qwixskinz" />
					<meta name="application-name" content="Qwixskinz" />
					<meta
						name="msapplication-config"
						content="/images/logo/browserconfig.xml"
					/>
					<meta name="theme-color" content="#ffffff" />

					<link href="/css/main.css" rel="stylesheet" />
				</head>

				<body ref={body => this.state} className={onHome ? "onHome" : ""}>
					<this.viewHelpers.SubViews routes={routes} />
					<script src={`/js/1.client.js?v=${this.cacheVer}`} />
					<script src={`/js/vendors~main.client.js?v=${this.cacheVer}`} />
					<script src={`/js/client.js?v=${this.cacheVer}`} />
				</body>
				</html>
		);
	}
}
